<template>
  <base-modal size="4xl" ref="modal" @hiding="reset">
    <base-card shadow noPadding>
      <div class="tw-flex tw-justify-between tw-items-center tw-p-4">
        <div>
          <div class="">Subject: {{ subject }}</div>
          <div class="tw-text-gray-500 tw-text-sm">Preview: {{ preview }}</div>
        </div>
        <base-icon><x-icon @click="hide" class="tw-w-5 tw-h-5"/></base-icon>
      </div>
      <div class="tw-mt-4 tw-rounded-b-md" v-html="htmlContent" />
    </base-card>
  </base-modal>
</template>
<script>
import { XIcon } from "@/assets/svgs";

export default {
  components: { XIcon },
  name: "ViewEmail",
  data() {
    return {
      subject: null,
      preview: null,
      htmlContent: null,
    };
  },
  methods: {
    show(subject, preview, htmlContent) {
      this.subject = subject;
      this.preview = preview;
      this.htmlContent = htmlContent;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.htmlContent = null;
    },
  },
};
</script>
